var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRequiredBadge16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "badge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.99976 8L7.33309 9.33333L9.99976 6.66667M5.22292 3.13136C5.70127 3.09319 6.15539 2.90509 6.52063 2.59383C7.37296 1.86749 8.62655 1.86749 9.47888 2.59383C9.84412 2.90509 10.2982 3.09319 10.7766 3.13136C11.8929 3.22045 12.7793 4.10687 12.8684 5.22316C12.9066 5.70151 13.0947 6.15564 13.4059 6.52088C14.1323 7.3732 14.1323 8.6268 13.4059 9.47912C13.0947 9.84436 12.9066 10.2985 12.8684 10.7768C12.7793 11.8931 11.8929 12.7796 10.7766 12.8686C10.2982 12.9068 9.84412 13.0949 9.47888 13.4062C8.62655 14.1325 7.37296 14.1325 6.52063 13.4062C6.15539 13.0949 5.70127 12.9068 5.22292 12.8686C4.10663 12.7796 3.2202 11.8931 3.13112 10.7768C3.09295 10.2985 2.90484 9.84436 2.59359 9.47912C1.86724 8.6268 1.86724 7.3732 2.59359 6.52088C2.90484 6.15564 3.09295 5.70151 3.13112 5.22316C3.2202 4.10687 4.10663 3.22045 5.22292 3.13136Z",
    stroke: "#FF9045",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRequiredBadge16);
export default __webpack_public_path__ + "static/media/icon-required-badge-16.7c90e7a8f3d0d9c373d7c26865194bd6.svg";
export { ForwardRef as ReactComponent };